<template>
    <div class="pointmall">
        <section>
            <swiper :options="swiperOption" ref="pmSwiper" v-if="bannerList.length > 0">
                <swiper-slide v-for="(item, index) in bannerList" :data-url="item.tb_url" :key="index">
                    <img :src="item.tb_image_url" class="banner-img cup" :data-url="item.tb_url" alt="">
                </swiper-slide>
                <div class="swiper-pagination df fdc jcc" slot="pagination"></div>
            </swiper>
            <div class="banner" v-else>
                <img src="https://www.bytter.com/upload/file/contents/2023/08/64eea1671fcae.jpg" alt="">
            </div>
        </section>
        <div class="container">

            <!-- 搜索 -->
            <div class="search df aic">

                <div class="search-box df aic">
                    <!-- 回车搜索 -->
                    <el-input v-model="searchIpt" :placeholder="$t('请输入您想要的礼品')" @keyup.enter="onSearch"></el-input>
                    <button class="btn fn cup" @click="onSearch">{{ $t('搜索') }}</button>
                </div>
                <!-- 可兑换礼品选择框 -->
                <el-checkbox v-model="onlyCanExchange" class="check-box ml-24 df aic">{{ $t('可兑换礼品') }}</el-checkbox>

            </div>

            <!-- 积分商城 -->
            <div class="mall-box">
                <div class="d1 df aic jcsb mb-30">
                    <span>{{ $t('积分商城') }}</span>
                    <el-checkbox v-model="onlyICanExchange" class="check-box ml-24 df aic">{{ $t('我可兑换')
                    }}</el-checkbox>
                </div>

                <div class="category-box df fww">
                    <span class="s1">{{ $t('类型') }}</span>
                    <div class="t1" @click="onClickType(item, index)" v-for="(item, index) in categoryList"
                        :key="item && item.value !== undefined ? item.value : index"
                        :class="{ 'active': categoryIndex === index }">{{ item && item.label ? item.label : item }}
                    </div>
                </div>

                <div class="category-box df fww">
                    <!-- asc 升序 -->
                    <!-- desc 降序 -->
                    <div :class="['s1', 'df']">
                        {{ $t('排序') }}
                        <!-- <div style="position: relative;left: 6px;width: 18px;">
                            <span class="iconfont fs-16 icon-shengxu-jiantou"></span><span
                                class="iconfont fs-16 icon-shengxu-jiantou-copy"></span>
                        </div> -->
                    </div>
                    <div v-for="(item, index) in sortList" class="df aic" @click="onClickSort(item, index)">
                        <div class="t1" :key="index + '1'" :class="{ 'active': sortIndex === index }">{{ $t(item) }}
                        </div>
                       
                        <div class="order-by"
                            :class="(sortIndex === 0 ? '' : (sortDirection === 'desc' ? 'desc' : 'asc'))"
                            :key="index" v-if="index > 0">
                            <span class="iconfont fs-16 icon-shengxu-jiantou"></span>
                            <span class="iconfont fs-16 icon-shengxu-jiantou-copy"></span>

                        </div>
                    </div>
                </div>

                <div class="product-box df fww">


                    <!-- 暂无数据 -->
                    <div class="no-data" v-if="productList.length === 0">
                        <img src="@/assets/images/empty_data.png" alt="">
                        <p>{{ $t('暂无数据') }}</p>
                    </div>

                    <div class="item" v-for="(item, index) in productList" :key="index" @click="toInfo(item.id)">
                        <div class="image">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="info">
                            <div class="name one-text">{{ item.name }}</div>
                            <div class="desc one-text">{{ item.desc }}</div>
                            <div class="popularity df">
                                <!-- 人气 -->
                                <div class="one-text">
                                    <span class="iconfont icon-a-svg5"></span>{{ item.popularity }}
                                </div>
                                <!-- 参考价格 -->
                                <div class="ml-24 one-text">
                                    {{ $t('参考价格') }}：{{ item.price }}
                                </div>
                            </div>
                            <!-- 积分 -->
                            <div class="point df aic jcsb">
                                <div class="text">
                                    {{ item.point }}<span>{{ $t('积分s') }}</span>
                                </div>
                                <button class="btn">{{ $t('立即兑换') }}</button>
                            </div>
                        </div>
                    </div>
                    <div ref="infiniteScrollSentinel" class="infinite-sentinel"></div>

                    <div class="ta-c c-9 pt-46 pb-26" style="width: 100%;" v-if="productList.length>0&&!hasMore">
                        {{ $t('暂无数据') }}
                    </div>


                </div>
            </div>

        </div>


    </div>

</template>

<script>
import { getGoodsList } from "@/api/pointmall";
import { getBanner } from "@api/home";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
    name: 'PointMall',
    components: { Swiper, SwiperSlide },
    data() {
        return {
            bannerList: [],
            swiperOption: {
                autoplay: { delay: 6000, disableOnInteraction: false },
                pagination: { el: ".swiper-pagination", clickable: true },
                on: {
                    slideChange: () => { this.addDynamicCircles(); },
                    click: (event) => { this.handleLinke(event.target.getAttribute('data-url')); }
                }
            },
            searchIpt: '',
            // 勾选：可兑换礼品（库存>0，未下架，结束时间>当前）
            onlyCanExchange: false,
            // 勾选：我可兑换（在可兑换基础上，积分余额>=商品积分）
            onlyICanExchange: false,
            // 过滤切换过程中抑制对方 watcher 的重复触发
            isTogglingFilters: false,
            // 类型
            categoryIndex: 0,
            categoryList: [],
            selectedTypeValue: 0,
            // 排序
            sortIndex: 0,
            sortList: ['全部', '兑换积分'],
            // 非“全部”选项的排序方向，默认第一次点击为倒序
            sortDirection: 'desc',

            // 商品数据（接口返回）
            productList: [],
            loading: false,
            // 用户积分余额（用于“我可兑换”筛选）
            userPoints: null,
            // 最新一次请求的序号，用于避免并发返回覆盖当前列表
            fetchTokenLatest: 0,
            // 分页：每次加载3行（行×4列=12条）
            currentPage: 1,
            pageSize: 12,
            hasMore: true, // 是否还有更多数据
            // 底部哨兵观察器实例
            io: null,
        }
    },
    watch: {
        onlyCanExchange(val) {
            // 互斥：勾选“可兑换礼品”则取消“我可兑换”
            if (val) {
                this.isTogglingFilters = true;
                this.onlyICanExchange = false;
                this.$nextTick(() => {
                    this.isTogglingFilters = false;
                    this.resetAndFetch();
                });
            } else {
                if (!this.isTogglingFilters) {
                    this.resetAndFetch();
                }
            }
        },
        async onlyICanExchange(val) {
            // 互斥：勾选“我可兑换”则取消“可兑换礼品”
            if (val) {
                this.isTogglingFilters = true;
                this.onlyCanExchange = false;
                await this.loadUserPoints().catch(() => { });
                this.$nextTick(() => {
                    this.isTogglingFilters = false;
                    this.resetAndFetch();
                });
            } else {
                if (!this.isTogglingFilters) {
                    this.resetAndFetch();
                }
            }
        },
        sortIndex() {
            this.resetAndFetch();
        }
    },
    created() {
        this.getBannerList();
        this.loadTypes();
        // 预取用户积分（不影响未登录场景）
        this.loadUserPoints().catch(() => { });
        this.resetAndFetch();
    },
    mounted() {
        this.$nextTick(() => { this.addDynamicCircles(); });
        const sentinel = this.$refs.infiniteScrollSentinel;
        if (sentinel && typeof window !== 'undefined') {
            this.io = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.loadMore();
                    }
                });
            }, { root: null, rootMargin: '200px', threshold: 0 });
            this.io.observe(sentinel);
        }
    },
    beforeDestroy() {
        if (this.io) {
            try { this.io.disconnect(); } catch (e) { }
            this.io = null;
        }
    },
    methods: {
        async getBannerList() {
            try {
            
                const res = await getBanner({ dd_id : 60 });
                if (res && res.status === 200 && Array.isArray(res.data)) {
                    this.bannerList = res.data;
                } else {
                    this.bannerList = [];
                }
            } catch (e) {
                this.bannerList = [];
            }
        },
        handleLinke(path) {
            if (path) { window.open(path, '_blank'); }
        },
        addDynamicCircles() {
            const existing = document.querySelectorAll('.swiper-pagination-bullet svg');
            existing.forEach(c => c.remove());
            const bullets = document.querySelectorAll('.swiper-pagination-bullet-active');
            bullets.forEach(bullet => {
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.setAttribute("width", "18");
                svg.setAttribute("height", "18");
                const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                circle.setAttribute("cx", "9");
                circle.setAttribute("cy", "9");
                circle.setAttribute("r", "8");
                circle.setAttribute("stroke", "#ffffff");
                circle.setAttribute("stroke-width", "1");
                circle.setAttribute("fill", "none");
                svg.appendChild(circle);
                bullet.appendChild(svg);
                circle.style.strokeDasharray = '50.24';
                circle.style.strokeDashoffset = '50.24';
                circle.style.animation = 'draw 6s forwards';
                circle.style.transform = 'rotate(180deg) scale(-1, 1)';
                circle.style.transformOrigin = 'center';
            });
        },

        // 排序
        handleSort(field) {
            // this.sortIndex = field === 'points' ? 1 : 0;
            // this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
            // this.resetAndFetch();
        },
        resetAndFetch() {
            this.currentPage = 1;
            this.hasMore = true;
            this.productList = [];
            this.fetchGoods(false);
        },
        loadMore() {
            if (this.loading || !this.hasMore) return;
            this.currentPage += 1;
            this.fetchGoods(true);
        },
        async loadUserPoints() {
            try {
                const { getMyPoints } = await import('@/api/pointmall');
                const res = await getMyPoints({});
                // 兼容不同返回结构，尽可能取到积分值
                const data = res && res.data ? res.data : {};
                const points = (
                    data.total ?? data.score ?? data.points ?? (data.user ? data.user.points : undefined) ?? 0
                );
                this.userPoints = Number(points) || 0;
            } catch (e) {
                // 无法获取时置为0，前端筛选将认为不可兑换
                this.userPoints = 0;
            }
        },
        async loadTypes() {
            try {
                const { getGoodsTypes } = await import('@/api/pointmall');
                const res = await getGoodsTypes({});
                if (res.status === 200 && Array.isArray(res.data)) {
                    this.categoryList = [{ label: this.$t('全部'), value: 0 }, ...res.data];
                }
            } catch (e) {
                console.error('获取商品类型失败', e);
            }
        },
        async fetchGoods(append = false) {
            this.loading = true;
            // 标记本次请求，避免并发返回覆盖最新状态
            const token = ++this.fetchTokenLatest;
            let sort = '';
            if (this.sortIndex === 1) {
                sort = 'points';
            } else {
                sort = '';
            }
            const params = {
                keywords: this.searchIpt || '',
                // 应用“可兑换礼品”的后端筛选：库存>0、未下架（默认20）、结束时间>当前
                // 当“我可兑换”勾选时也应用该后端筛选，然后前端再按积分余额过滤
                only_can_exchange: (this.onlyCanExchange || this.onlyICanExchange) ? 1 : 0,
                sort,
                sort_order: this.sortIndex === 0 ? '' : this.sortDirection,
                pageindex: this.currentPage,
                pagesize: this.pageSize,
                tg_type: this.selectedTypeValue && this.selectedTypeValue > 0 ? this.selectedTypeValue : undefined,
            };
            if (!sort) {
                delete params.sort;
                delete params.sort_order;
            }
            try {
                const loading = this.$loading({
                    lock: true,
                    text: this.$t("拼命加载中"),
                    spinner: "el-icon-loading",
                    background: "rgba(255, 255, 255, 0.7)",
                });
                const res = await getGoodsList(params);
                loading.close();
                if (res.status === 200 && res.data && Array.isArray(res.data.data)) {
                    let list = res.data.data.map(item => ({
                        id: item.tg_id,
                        name: item.tg_name,
                        desc: item.tg_specs || '',
                        popularity: item.tg_pop || 0,
                        price: item.tg_ref_price || 0,
                        stock: item.tg_available_qty || 0,
                        point: item.tg_points || 0,
                        image: item.tg_main_image_attr || '',
                        canExchangeWindow: item.can_exchange_window || 0,
                    }));
                    // 我可兑换：在“可兑换礼品”基础上，用户积分余额>=商品积分
                    if (this.onlyICanExchange) {
                        const balance = Number(this.userPoints || 0);
                        list = list.filter(g => Number(g.point || 0) <= balance);
                    }
                    // 仅当仍是最新请求时才更新列表
                    if (token === this.fetchTokenLatest) {
                        if (append) {
                            this.productList = [...this.productList, ...list];
                        } else {
                            this.productList = list;
                        }
                        this.hasMore = Array.isArray(res.data.data) && res.data.data.length >= this.pageSize;
                    }
                }
            } catch (e) {
                console.error('获取商品列表失败', e);
            } finally {
                this.loading = false;
            }
        },
        onClickSort(item, index) {
            // “全部”不切换方向，固定倒序
            if (index === 0) {
                this.sortIndex = 0;
                this.sortDirection = 'desc';
                return; // 交由 watch(sortIndex) 触发刷新
            }
            // 切换到新排序项，方向默认倒序
            if (this.sortIndex !== index) {
                this.sortIndex = index;
                this.sortDirection = 'desc';
                return; // 交由 watch(sortIndex) 触发刷新
            }
            // 重复点击同一项时，切换方向并手动刷新
            this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
            this.fetchGoods();
        },
        onSearch() {
            this.fetchGoods();
        },
        toInfo(id) {
            this.$router.push({ name: 'POINTMALL_INFO', params: { id } })
        },
        onClickType(item, index) {
            this.categoryIndex = index;
            this.selectedTypeValue = item && item.value ? item.value : 0;
            this.fetchGoods();
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding: 0 80px;

}

.pointmall {
    margin-top: 60px;
}

.product-box {
    padding-top: 8px;

    .item {
        width: calc(25% - 18px);
        margin-right: 24px;
        margin-top: 32px;
        border-radius: 8px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
        background: rgba(255, 255, 255, 1);
        overflow: hidden;
        cursor: pointer;

        &:hover {
            .name {
                color: rgba(183, 37, 30, 1);
            }

            .image {

                img {
                    transform: scale(1.02);
                }
            }
        }

    }

    .infinite-sentinel {
        width: 100%;
        height: 1px;
    }

    .point {
        margin-top: 16px;

        .text {
            color: rgba(183, 37, 30, 1);
            font-family: "MicrosoftYaHeiSemibold";
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;
            letter-spacing: 1px;
        }

        .btn {
            border: none;
            outline: none;
            min-width: 92px;
            height: 34px;
            padding: 0 16px;
            border-radius: 19px;
            background: rgba(255, 237, 235, 1);
            font-size: 14px;
            color: rgba(183, 37, 30, 1);
            cursor: pointer;

        }
    }

    .popularity {
        color: rgba(89, 89, 89, 1);
        font-family: 'harmonyos';
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 8px;

        .iconfont {
            color: #B7251E;
        }
    }

    .info {
        height: 164px;
        padding: 16px 16px;

        .name {
            color: #191919;
            font-family: "harmonyos";
            font-size: 18px;
            font-weight: 400;
            line-height: 28px;
        }

        .desc {
            color: rgba(89, 89, 89, 1);
            font-family: "harmonyos";
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            margin-top: 4px;
        }
    }

    .item:nth-child(4n) {
        margin-right: 0;
    }

    .image {
        width: 100%;
        padding-bottom: 100%;
        position: relative;
        overflow: hidden;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.36s;
        }
    }

}

.mall-box {
    max-width: 1400px;
    margin: 0 auto;
    border: 1px solid rgba(243, 243, 243, 1);
    border-radius: 8px;
    padding: 24px 40px 32px;
    margin-bottom: 40px;

    .order-by {
        position: relative;
        left: -4px;
        cursor: pointer;

        .iconfont {
            // color: #;
            font-size: 20px;
            font-weight: 600;
            color: rgb(89, 89, 89);
            opacity: 0.6;
        }

        .iconfont:nth-child(2) {
            position: relative;
            left: -15px;
        }

        &.asc {
            .iconfont:nth-child(1) {
                color: #b7251e;
                opacity: 1;
            }

            .iconfont:nth-child(2) {
                color: rgb(89, 89, 89);
                opacity: 0.6;
            }
        }

        &.desc {
            .iconfont:nth-child(1) {
                color: rgb(89, 89, 89);
                opacity: 0.6;
            }

            .iconfont:nth-child(2) {
                color: #b7251e;
                opacity: 1;
            }
        }
    }

    .category-box {
        font-size: 14px;
        line-height: 28px;
        margin-top: 12px;

        .s1 {
            min-width: 62px;
            line-height: 26px;
            color: #191919;
            font-family: "MicrosoftYaHeiSemibold";
            position: relative;




        }

        .t1 {
            color: rgba(0, 0, 0, 0.9);
            font-weight: 400;
            min-width: 74px;
            text-align: center;
            padding: 0 16px;
            margin-right: 8px;
            cursor: pointer;
            text-align: center;

            &:hover {
                color: #B7251E;
            }

            &.active {
                color: #B7251E;
                border-radius: 21px;
                background: rgba(254, 242, 242, 1);
            }
        }
    }

    .d1 {
        font-family: "MicrosoftYaHeiSemibold";
        color: #191919;
        font-size: 22px;
        font-weight: 400;
        line-height: 24px;
    }
}

.search {
    max-width: 1400px;
    margin: 40px auto 27px;




    .search-box {
        width: 746px;
        height: 40px;
        border: 1px solid #999999;
        border-radius: 20px;
        overflow: hidden;
        padding: 0 0px 0 22px;

        &:hover {
            border-color: #b7251e;
        }

        ::v-deep .el-input__inner {
            border: none;
            padding: 0 !important;
        }

        .btn {
            height: 40px;
            padding-left: 22px;
            padding-right: 22px;
            background: transparent;
            border: none;
            outline: none;
            color: #191919;

            &:hover {
                color: #B7251E;
            }
        }
    }
}

.banner {
    width: 100%;
    max-height: 420px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        /* 图片等比缩放并填满容器 */
        object-position: center center;
        /* 图片居中显示，超出部分被裁剪 */
    }

}

.swiper-container {
    .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.swiper-pagination {
    width: 16px;
    padding-top: 18px;
    left: auto;
    right: 42px;
    top: 0;
}

::v-deep() {
    .swiper-pagination .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        background: #ffffff;
        margin: 8px 0;
        opacity: 0.6;
    }
    .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active { opacity: 1; }
}

@keyframes draw { to { stroke-dashoffset: 0; } }

::v-deep() {
    .check-box {
        .el-checkbox__label {
            color: rgba(25, 25, 25, 1);
            font-size: 16px;
            font-weight: 400;
            padding-left: 6px;
        }

        .el-checkbox__inner::after {
            left: 6px !important;
            top: 2px !important;
        }

        .el-checkbox__inner {
            width: 17px;
            height: 17px;
            border-color: #999999 !important;
            border-radius: 50% !important;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: #b7251e !important;
        }
    }

}
</style>
